var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('milestone-wrapper',{attrs:{"subscription-period-id":_vm.subscriptionPeriodId,"data":_vm.data,"meta":_vm.meta}},[_c('template',{slot:"content-completed"},[(_vm.content)?_c('vendor-invoice',{attrs:{"data":_vm.content}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }